/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_ReanimatedInputs */

const en_svchip_reanimated = /** @type {(inputs: Svchip_ReanimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reanimated`)
};

const ar_svchip_reanimated = /** @type {(inputs: Svchip_ReanimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reanimated`)
};

const bn_svchip_reanimated = /** @type {(inputs: Svchip_ReanimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reanimated`)
};

const de_svchip_reanimated = /** @type {(inputs: Svchip_ReanimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederbelebt`)
};

const es_svchip_reanimated = /** @type {(inputs: Svchip_ReanimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reanimado`)
};

const fr_svchip_reanimated = /** @type {(inputs: Svchip_ReanimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réanimé`)
};

const pt_svchip_reanimated = /** @type {(inputs: Svchip_ReanimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reanimado`)
};

const zh_svchip_reanimated = /** @type {(inputs: Svchip_ReanimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复活`)
};

const tr_svchip_reanimated = /** @type {(inputs: Svchip_ReanimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeniden canlandırıldı`)
};

const ru_svchip_reanimated = /** @type {(inputs: Svchip_ReanimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Реанимирован`)
};

const pl_svchip_reanimated = /** @type {(inputs: Svchip_ReanimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ożywiony`)
};

/**
* | output |
* | --- |
* | "Reanimated" |
*
* @param {Svchip_ReanimatedInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_reanimated = /** @type {((inputs?: Svchip_ReanimatedInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_ReanimatedInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_reanimated(inputs)
	if (locale === "bn") return bn_svchip_reanimated(inputs)
	if (locale === "de") return de_svchip_reanimated(inputs)
	if (locale === "es") return es_svchip_reanimated(inputs)
	if (locale === "fr") return fr_svchip_reanimated(inputs)
	if (locale === "pt") return pt_svchip_reanimated(inputs)
	if (locale === "zh") return zh_svchip_reanimated(inputs)
	if (locale === "tr") return tr_svchip_reanimated(inputs)
	if (locale === "ru") return ru_svchip_reanimated(inputs)
	if (locale === "pl") return pl_svchip_reanimated(inputs)
	return en_svchip_reanimated(inputs)
});